import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import getFeatureFlag from 'utils/functions/getFeatureFlags';
import styles from './B2CBanner.module.scss';

function B2CBanner() {
  return getFeatureFlag('diagnostic_turma_info').isOn ? (
    <aside className={styles.wrapper}>
      <div className={`${styles.info} ${styles.dark}`}>
        <div>
          <span>ATIVIDADE DIAGNÓSTICA</span>
          <h2>Bem-vindo(a) à sua atividade diagnóstica!</h2>
        </div>
        <p>
          Antes de começar sua jornada na Letrus, você realizará uma redação
          diagnóstica. Ela é o ponto de partida : nos ajuda a entender como você
          s eu desenvolvimento.
        </p>

        <p>
          Após o envio, nossa IA fará uma análise inicial da sua redação. Em
          seguida, nossa equipe pedagógica revisará tudo em até 48h para
          garantir que o seu nivelamento seja preciso.
        </p>

        <p>
          Assim que a avaliação for concluída, suas atividades do mês aparecerão
          automaticamente aqui no seu painel. Você também receberá um e-mail
          assim que estiver tudo pronto.
        </p>
      </div>

      <div className={styles.info}>
        <div>
          <span>POR QUE 48H?</span>
          <h2>Sua avaliação é feita com cuidado.</h2>{' '}
        </div>
        <p>
          Nossa equipe pedagógica revisa cada diagnóstica para garantir que suas
          atividades foquem exatamente onde você mais precisa evoluir. É essa
          etapa que torna o programa personalizado, não tamanho-único.
        </p>

        <ul>
          <li>
            <FontAwesomeIcon icon={['fal', 'clock']} color="#40357c" />
            Recebimento e análise inicial pela IA — até 12h.
          </li>

          <li>
            <FontAwesomeIcon icon={['fal', 'sparkles']} color="#40357c" />{' '}
            Revisão pedagógica e nivelamento — até 24h.
          </li>

          <li>
            <FontAwesomeIcon icon={['fal', 'circle-check']} color="#00c341" />{' '}
            Atividades do mês liberadas no seu painel.
          </li>
        </ul>
      </div>
    </aside>
  ) : (
    <></>
  );
}

export default B2CBanner;
